<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <ng-template #title>
      <h1>
        {{ 'label.routes' | translate }}
      </h1>
    </ng-template>

    <p-table
      #routesTable
      [value]="routeService.routes()"
      stripedRows
      showGridlines
      dataKey="id"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="name"
      [sortOrder]="1"
      [scrollable]="true"
      [loading]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      [globalFilterFields]="globalFilterFields"
    >
      <ng-template #header>
        <tr>
          <th style="width: 3rem"></th>
          @for (column of routeColumns; track $index) {
            <th [pSortableColumn]="column.field" pResizableColumn>
              {{ column.header | translate }}
              @if (column.sortField) {
                <p-sortIcon [field]="column.sortField" />
              }
            </th>
          }
          <th>{{ 'routeSection.count' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-route let-expanded="expanded">
        <tr>
          <td style="width: 3rem">
            <p-button
              type="button"
              pRipple
              [pRowToggler]="route"
              [text]="true"
              severity="secondary"
              [rounded]="true"
              [icon]="
                expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
              "
            />
          </td>
          @for (column of routeColumns; track $index) {
            <td>
              {{ route[column.field] }}
            </td>
          }
          <td>
            {{ route.sections?.length ?? 0 }}
          </td>
        </tr>
      </ng-template>
      <ng-template #expandedrow let-route>
        <tr>
          <td [attr.colspan]="routeColumns.length + 2" class="p-10">
            <app-route-section-table
              [route]="route"
              (sectionChanged)="onSectionChanged()"
            ></app-route-section-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-confirmdialog />
  </p-card>
</div>
